import { Injectable } from '@angular/core';
import { ISplugDefinitionDto, ISplugValidationDto, LSplug } from 'core/dto';
import { IControl } from 'core/dynamic-form';
import { mapKey } from 'core/rx-js';
import { Observable, map } from 'rxjs';
import { ApiService } from '../api.service';
import { controllerEndpoints } from '../controller.endpoints';
import joinUrls from '../utils.ts/join-urls';
import { ICrudAdvancedMethods } from './types/i-crud-advanced.methods';


export interface ISplugDefinition {

  id: string

  splugId: LSplug
  title: string,
  description?: string,
  disabledOnMobile?: boolean,
  controls?: IControl[]
}

@Injectable({
  providedIn: 'root'
})
export class SplugDefinitionRemoteControllerService implements Pick<ICrudAdvancedMethods<ISplugDefinitionDto>, 'getMany'> {

  private readonly _endpoint = controllerEndpoints.SPLUG_DEFINITION;
  private readonly VALIDATE_SPLUG_PARAMS = 'validateSplugParams'
  constructor(
    private readonly _apiService: ApiService
  ) {

  }

  getMany(): Observable<ISplugDefinition[]> {

    return this._apiService.get<{ pluginInfo: ISplugDefinitionDto[] }>(this._endpoint)
      .pipe(
        mapKey('pluginInfo'),
        map((splugDefinitionDtos) =>
          [
            ...splugDefinitionDtos.map<ISplugDefinition>((dto) => ({
              id: dto.id,
              splugId: dto.type === 'local' ? 'signergy' : dto.type,
              title: dto.description,
              description: dto.description,
              disabledOnMobile: dto.disabledOnMobile,
              controls: dto?.splugActionParams.map<IControl>((actionParam) => ({
                dataField: actionParam.key,
                label: actionParam.label,
                type: actionParam.type as any,
                colSpan: actionParam.type === 'checklist' ? 2 : 1,
                defaultValue: actionParam.defaultValue,
                validationRules: actionParam.required ? [{ type: 'required' }] : undefined,
                options: actionParam.listItems ?
                  {
                    listItems: actionParam.listItems
                  }
                  : undefined
              }))
            })),
            // {
            //   id: 'signergy',
            //   splugId: 'signergy',
            //   title: 'Signergy',
            //   controls: [
            //     {
            //       dataField: 'onlyQualified',
            //       label: 'Samo kvalificirani',
            //       type: 'checkbox',
            //       defaultValue: true,
            //       validationRules: [{ type: 'required' }]
            //     },
            //     {
            //       dataField: 'signergyOpts',
            //       type: 'checklist',
            //       defaultValue: [1, 2, 6],
            //       label: 'Opcije signergy',
            //       options: {
            //         listItems: [
            //           { text: 'prop 1', value: 1 },
            //           { text: 'prop 2', value: 2 },
            //           { text: 'prop 3', value: 3 },
            //           { text: 'prop 4', value: 4 },
            //           { text: 'prop 5', value: 5 },
            //           { text: 'prop 6', value: 6 },
            //           { text: 'prop 7', value: 7 },
            //           { text: 'prop 8', value: 8 },
            //         ],
            //       }
            //     }
            // ]
            //   }
          ]
        )
      )
  }

  validateSplugParams(splugId: string, splugParams: { key: string, value: any }[]) {
    const validateSplugsEndpoint = joinUrls(this._endpoint, this.VALIDATE_SPLUG_PARAMS, splugId)
    return this._apiService.put<ISplugValidationDto>(validateSplugsEndpoint, splugParams);
  }

}
